let variantTimeout;

document.addEventListener('click', function (e) {
    const li = e.target.closest('.tt-options-swatch.options-large li');
    if (!li) return;

    clearTimeout(variantTimeout);
    variantTimeout = setTimeout(() => {
        const productForm = document.querySelector('[bss-b2b-main-product-form]');
        if (!productForm) return;

        BSS_B2B.observer.productSubject.notifyObserver(
            'VariantChange',
            'VariantSelectChange',
            { productForm }
        );
    }, 300);
});
